import TimeSlotSelect from './TimeSlotSelect'

export default TimeSlotSelect
